export default __webpack_public_path__ + "static/media/faceoutline.06b80ade.png";